export default __webpack_public_path__ + "static/media/apple-store.2f2be32e.svg";